import React from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import HeaderWithBackButton from 'redesign/components/organisms/headers/header-with-back-button'
import Page from 'redesign/components/templates/Page'
import AnnouncementsList from 'redesign/components/templates/announcements-list'
import { ANNOUNCEMENTS_PAGE_ROOT_ID } from './constants'
import { usePageAnnouncements } from './use-page-announcements'

const AnnouncementsPage: React.FC = () => {
  const { t } = useFavurTranslation()
  const { handleClick, loading, list, loadMore, hasMoreElements } = usePageAnnouncements()

  return (
    <Page
      header={<HeaderWithBackButton title={t('page.announcements.header.title')} />}
      rootId={ANNOUNCEMENTS_PAGE_ROOT_ID}
    >
      <AnnouncementsList
        isLoading={loading}
        announcements={list}
        loadMore={loadMore}
        showLoadMoreButton={hasMoreElements}
        handleClick={handleClick}
      />
    </Page>
  )
}

export default AnnouncementsPage
